export default "__VITE_ASSET__KVCbjSa___"